/**
 * Author: Stefan Haack (https://shaack.com)
 */
import {ChessConsoleState} from "../../lib/chess-console/ChessConsoleState.js"

export class GambitChessConsoleState extends ChessConsoleState {

    constructor(props) {
        super(props)
    }
}

